var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgControlsMetricActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8735_299597",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2.5H21.5V21.5H2.5V2.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8735_299597)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41152 18.0456C8.45722 18.9999 6.90998 18.9999 5.95564 18.0456C5.00134 17.0912 5.00134 15.544 5.95564 14.5897L8.55441 11.9909C8.79614 11.7492 8.79614 11.3573 8.55441 11.1155C8.31268 10.8738 7.92076 10.8738 7.67904 11.1155L5.08027 13.7143C3.64251 15.1521 3.64251 17.4832 5.08027 18.9209C6.51806 20.3587 8.84913 20.3587 10.2869 18.9209C10.2869 18.9209 10.2869 18.9209 10.2869 18.9209L12.8857 16.3222C13.1274 16.0804 13.1274 15.6885 12.8857 15.4468C12.6439 15.2051 12.252 15.2051 12.0103 15.4468L9.41153 18.0456L9.41152 18.0456Z",
    fill: "#1DD899"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4479 12.8827C15.6896 13.1244 16.0815 13.1244 16.3232 12.8827L18.922 10.2839C20.3597 8.84615 20.3597 6.51504 18.922 5.07728C17.4842 3.6395 15.1531 3.63949 13.7154 5.07728C13.7154 5.07728 13.7154 5.07728 13.7154 5.07729L11.1166 7.67605C10.8749 7.91777 10.8749 8.30969 11.1166 8.55142C11.3583 8.79314 11.7502 8.79314 11.992 8.55142L14.5907 5.95265L14.5907 5.95265C15.545 4.99832 17.0923 4.99831 18.0466 5.95265C19.0009 6.90696 19.0009 8.45423 18.0466 9.40853L15.4479 12.0073C15.2061 12.249 15.2061 12.6409 15.4479 12.8827Z",
    fill: "#1DD899"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.61192 7.61289C7.85365 7.37117 7.85365 6.97925 7.61192 6.73752L6.31253 5.43813C6.0708 5.1964 5.67888 5.1964 5.43715 5.43813C5.19543 5.67985 5.19543 6.07177 5.43715 6.3135L6.73655 7.61289C6.97828 7.85462 7.3702 7.85462 7.61192 7.61289Z",
    fill: "#1DD899"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.61192 7.61289C7.85365 7.37117 7.85365 6.97925 7.61192 6.73752L6.31253 5.43813C6.0708 5.1964 5.67888 5.1964 5.43715 5.43813C5.19543 5.67985 5.19543 6.07177 5.43715 6.3135L6.73655 7.61289C6.97828 7.85462 7.3702 7.85462 7.61192 7.61289Z",
    fill: "#1DD899"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 8.90665C4 9.24851 4.27713 9.52563 4.61898 9.52563H6.45658C6.79843 9.52563 7.07556 9.24851 7.07556 8.90665C7.07556 8.5648 6.79843 8.28767 6.45658 8.28767H4.61898C4.27713 8.28767 4 8.5648 4 8.90665Z",
    fill: "#1DD899"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 8.90665C4 9.24851 4.27713 9.52563 4.61898 9.52563H6.45658C6.79843 9.52563 7.07556 9.24851 7.07556 8.90665C7.07556 8.5648 6.79843 8.28767 6.45658 8.28767H4.61898C4.27713 8.28767 4 8.5648 4 8.90665Z",
    fill: "#1DD899"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.90609 7.07642C9.24794 7.07642 9.52507 6.79929 9.52507 6.45744V4.61983C9.52507 4.27798 9.24794 4.00085 8.90609 4.00085C8.56424 4.00085 8.28711 4.27798 8.28711 4.61983V6.45744C8.28711 6.79929 8.56424 7.07642 8.90609 7.07642Z",
    fill: "#1DD899"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.90609 7.07642C9.24794 7.07642 9.52507 6.79929 9.52507 6.45744V4.61983C9.52507 4.27798 9.24794 4.00085 8.90609 4.00085C8.56424 4.00085 8.28711 4.27798 8.28711 4.61983V6.45744C8.28711 6.79929 8.56424 7.07642 8.90609 7.07642Z",
    fill: "#1DD899"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5621 18.5631C18.8038 18.3214 18.8038 17.9294 18.5621 17.6877L17.2627 16.3883C17.021 16.1466 16.6291 16.1466 16.3874 16.3883C16.1456 16.63 16.1456 17.022 16.3874 17.2637L17.6867 18.5631C17.9285 18.8048 18.3204 18.8048 18.5621 18.5631Z",
    fill: "#1DD899"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5621 18.5631C18.8038 18.3214 18.8038 17.9294 18.5621 17.6877L17.2627 16.3883C17.021 16.1466 16.6291 16.1466 16.3874 16.3883C16.1456 16.63 16.1456 17.022 16.3874 17.2637L17.6867 18.5631C17.9285 18.8048 18.3204 18.8048 18.5621 18.5631Z",
    fill: "#1DD899"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0926 19.9993C15.4345 19.9993 15.7116 19.7221 15.7116 19.3803V17.5427C15.7116 17.2008 15.4345 16.9237 15.0926 16.9237C14.7508 16.9237 14.4736 17.2008 14.4736 17.5427V19.3803C14.4736 19.7221 14.7508 19.9993 15.0926 19.9993Z",
    fill: "#1DD899"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0926 19.9993C15.4345 19.9993 15.7116 19.7221 15.7116 19.3803V17.5427C15.7116 17.2008 15.4345 16.9237 15.0926 16.9237C14.7508 16.9237 14.4736 17.2008 14.4736 17.5427V19.3803C14.4736 19.7221 14.7508 19.9993 15.0926 19.9993Z",
    fill: "#1DD899"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9238 15.0932C16.9238 15.435 17.201 15.7122 17.5428 15.7122H19.3804C19.7223 15.7122 19.9994 15.435 19.9994 15.0932C19.9994 14.7513 19.7223 14.4742 19.3804 14.4742H17.5428C17.201 14.4742 16.9238 14.7513 16.9238 15.0932Z",
    fill: "#1DD899"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9238 15.0932C16.9238 15.435 17.201 15.7122 17.5428 15.7122H19.3804C19.7223 15.7122 19.9994 15.435 19.9994 15.0932C19.9994 14.7513 19.7223 14.4742 19.3804 14.4742H17.5428C17.201 14.4742 16.9238 14.7513 16.9238 15.0932Z",
    fill: "#1DD899"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlsMetricActive);
export default __webpack_public_path__ + "static/media/controlsMetricActive.988951ad9b112dcb148d7d0f76bf9d4f.svg";
export { ForwardRef as ReactComponent };